import React from "react";

export interface IconEditProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const IconEdit: React.FC<IconEditProps> = ({
  width = 38,
  height = 36,
  fill = "#006231",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 36"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M26.5604 5.81099L32.5111 12.1185C32.7618 12.3842 32.7618 12.8177 32.5111 13.0835L18.1028 28.3557L11.9806 29.0759C11.1625 29.1738 10.4698 28.4396 10.5622 27.5725L11.2417 21.0832L25.65 5.81099C25.9007 5.54526 26.3097 5.54526 26.5604 5.81099ZM37.2479 4.20964L34.0285 0.797175C33.0257 -0.265725 31.3962 -0.265725 30.3868 0.797175L28.0514 3.27261C27.8007 3.53834 27.8007 3.97189 28.0514 4.23762L34.0021 10.5451C34.2528 10.8108 34.6618 10.8108 34.9125 10.5451L37.2479 8.06965C38.2507 6.99976 38.2507 5.27254 37.2479 4.20964ZM25.3333 24.202V31.3206H4.22222V8.94375H19.3826C19.5938 8.94375 19.7917 8.85284 19.9434 8.699L22.5823 5.90189C23.0837 5.37044 22.7274 4.46838 22.0215 4.46838H3.16667C1.4184 4.46838 0 5.97182 0 7.8249V32.4394C0 34.2925 1.4184 35.796 3.16667 35.796H26.3889C28.1372 35.796 29.5556 34.2925 29.5556 32.4394V21.4049C29.5556 20.6566 28.7045 20.286 28.2031 20.8105L25.5642 23.6076C25.4191 23.7684 25.3333 23.9782 25.3333 24.202Z" />
  </svg>
);
